(() => {
  const header = document.querySelector('.shopify-section--header');
  if (!header) return;
  let lastPosition = window.scrollY;
  let scheduled = false;
  const update = () => {
    const position = window.scrollY;
    const difference = position - lastPosition;
    if (position < 180 || difference < -6 || header.contains(document.activeElement)) {
      header.classList.remove('jsc-header-hidden');
    } else if (difference > 6 && position > 240) {
      header.classList.add('jsc-header-hidden');
    }
    if (Math.abs(difference) > 6) lastPosition = position;
    scheduled = false;
  };
  window.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  header.addEventListener('focusin', () => header.classList.remove('jsc-header-hidden'));
})();
